import React, { useEffect, useRef, useState } from 'react';
import styles from './ChatConsoleSidebar.module.scss';
import ChatHeader from './components/chat-header/ChatHeader';
import Chats from './components/chat-body/Chats';
import SvgWithBranding from 'component/hoc/branding/withBrandingColor.hoc';
import { isEmpty } from 'lodash';
import Loader from 'component/atom/loader/Loader';
import { chat } from 'hooks/endpoints';

const ChatConsoleSidebar = ({
  isOpen,
  setIsOpen,
  getActiveChat,
  chatsData,
  onNewChatClick,
  onSearch,
  refetchChatsList,
  isLoading,
}) => {
  const [currentChat, setCurrentChat] = useState('');

  const setLastChatSelection = (nextList) => {
    const list = Array.isArray(nextList) ? nextList : chatsData;
    if (!Array.isArray(list) || list.length === 0) return;

    const firstId = list.slice().reverse()[0]?.chatId;
    if (!firstId) return;

    setCurrentChat(firstId);
    getActiveChat(firstId);
  };

  return (
    <div className={styles['chat-sidebar']}>
      <ChatHeader
        onMenuClick={setIsOpen}
        isOpen={isOpen}
        onSearch={onSearch}
        onNewChatClick={onNewChatClick}
      />

      <div className={styles['chat-body']}>
        {!isEmpty(chatsData) ? (
          <Chats
            data={chatsData?.slice().reverse()}
            title='today'
            getActiveChat={getActiveChat}
            currentChat={currentChat}
            refetchChatsList={refetchChatsList}
            setLastChatSelection={setLastChatSelection}
          />
        ) : isEmpty(chatsData) && !isLoading ? (
          <div className={styles['no-data']}>
            <SvgWithBranding type='noChat' />
            <p>No Chat Found</p>
          </div>
        ) : (
          <></>
        )}
      </div>
    </div>
  );
};

export default ChatConsoleSidebar;
